<div class="border-default overflow-x-auto rounded-sm border">
  <table class="w-full border-collapse text-xs">
    <thead>
      <tr class="bg-elevated border-weak border-b">
        <th class="w-8 px-2 py-1.5">
          <app-checkbox
            data-testid="deploy-sites-select-all"
            [checked]="allSelected()"
            [indeterminate]="someSelected()"
            [disabled]="locked()"
            [label]="''"
            [onChange]="() => onToggleAll()" />
        </th>
        <th
          class="text-text-tertiary px-2 py-1.5 text-left text-[10.5px] font-semibold tracking-wider uppercase">
          {{ 'features.plan.deploy.table.uid' | translate }}
        </th>
        <th
          class="text-text-tertiary px-2 py-1.5 text-left text-[10.5px] font-semibold tracking-wider uppercase">
          {{ 'features.plan.deploy.table.label' | translate }}
        </th>
        <th
          class="text-text-tertiary px-2 py-1.5 text-left text-[10.5px] font-semibold tracking-wider uppercase">
          {{ 'features.plan.deploy.table.state' | translate }}
        </th>
      </tr>
    </thead>

    <tbody>
      @for (row of rows(); track row.uid) {
        <!-- An open row and its detail row hover as one: they are one site. -->
        <tr
          data-testid="deploy-site-row"
          [attr.data-uid]="row.uid"
          class="border-weak hover:bg-interactive has-[+[data-testid=deploy-site-detail]:hover]:bg-interactive [&:hover+[data-testid=deploy-site-detail]]:bg-interactive transition-colors last:border-b-0"
          [class.border-b]="!isExpanded(row.uid)">
          <td class="px-2 py-1.5 align-top">
            <app-checkbox
              [checked]="row.selected"
              [disabled]="locked()"
              [label]="''"
              [onChange]="() => toggleUid.emit(row.uid)" />
          </td>

          <!-- Green where the messages table puts it, and for the same reason: the operator
               scans this column to find a site, so "this one went out" belongs where the eye
               already is. -->
          <td
            class="px-2 py-1.5 align-top font-mono tabular-nums"
            [class.text-success]="row.deployed">
            {{ row.uid }}
          </td>

          <!-- An em dash rather than a key: punctuation reads the same in every locale, and
               repeating the uid here would say nothing the previous cell has not. -->
          <td class="text-text-secondary px-2 py-1.5 align-top">{{ row.name ?? '—' }}</td>

          <td class="px-2 py-1.5 align-top">
            @if (row.warnings.length > 0) {
              <button
                type="button"
                data-testid="deploy-site-warnings-toggle"
                class="cursor-pointer rounded-full transition-opacity hover:opacity-80"
                [attr.data-blocked]="row.blocked"
                [attr.aria-expanded]="isExpanded(row.uid)"
                [attr.aria-label]="
                  'features.plan.deploy.table.toggle_warnings'
                    | translate: { count: row.warnings.length }
                "
                (click)="toggleDetail(row.uid)">
                <app-status-pill
                  [variant]="row.blocked ? 'danger' : 'warning'"
                  [dot]="true">
                  {{
                    (row.blocked
                      ? 'features.plan.deploy.table.invalid'
                      : 'features.plan.deploy.table.warning_count'
                    ) | translate: { count: row.warnings.length }
                  }}
                  <i
                    [class]="ICONS.caretDown"
                    class="text-[10px] transition-transform"
                    [class.rotate-180]="isExpanded(row.uid)"
                    aria-hidden="true"></i>
                </app-status-pill>
              </button>
            }
          </td>
        </tr>

        @if (row.warnings.length > 0 && isExpanded(row.uid)) {
          <tr
            data-testid="deploy-site-detail"
            class="border-weak bg-elevated hover:bg-interactive border-b transition-colors last:border-b-0">
            <td [attr.colspan]="columnCount" class="pt-0.5 pr-2 pb-2 pl-10">
              <app-deploy-warnings-list [messages]="row.warnings" [dense]="true" />
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</div>
